export const DEFAULT_LANG = 'sk';

export function resolveDefaultTitleByLang(lang?: string): string {
  switch (lang) {
    case 'cz':
      return 'SUPERGOLF.CZ';
    case 'en':
      return 'GOLF CENTRUM.online';
    default:
      return 'GOLF CENTRUM.sk';
  }
}

export function resolveOrganizationInfoByLang(
  lang?: string,
): { name: string; telephone: string; email: string } {
  switch (lang) {
    case 'cz':
      return {
        name: resolveDefaultTitleByLang(lang),
        telephone: '',
        email: 'eshop@supergolf.cz',
      };
    default:
      return {
        name: resolveDefaultTitleByLang(lang),
        telephone: '+421918328980',
        email: 'eshop@golfcentrum.sk',
      };
  }
}

export function resolveHtmlLangByLang(lang?: string): string {
  switch (lang) {
    case 'cz':
      return 'cs';
    case 'en':
      return 'en';
    default:
      return 'sk';
  }
}

export function resolveMetaDescriptionSuffixByLang(lang?: string): string {
  switch (lang) {
    case 'cz':
      return 'Kupte online na SUPERGOLF.CZ – ověřený golfový e-shop, rychlé doručení a odborné poradenství.';
    case 'en':
      return 'Buy online at GOLF CENTRUM – trusted golf store with fast delivery and expert advice.';
    default:
      return 'Kúpte online na GOLF CENTRUM.sk – overený golfový e-shop, rýchle doručenie a odborné poradenstvo.';
  }
}

export function resolveArticleSectionSuffixByLang(lang?: string): string {
  switch (lang) {
    case 'cz':
      return 'Články, novinky a tipy ze světa golfu na SUPERGOLF.CZ.';
    case 'en':
      return 'Articles, news and tips from the world of golf at GOLF CENTRUM.';
    default:
      return 'Články, novinky a tipy zo sveta golfu na GOLF CENTRUM.sk.';
  }
}

export function resolveHomepageHeadingByLang(lang?: string): string {
  switch (lang) {
    case 'cz':
      return 'Golfový obchod – golfové hole, bagy, míčky a oblečení';
    case 'en':
      return 'Golf shop – golf clubs, bags, balls and apparel';
    default:
      return 'Golfový obchod – golfové palice, bagy, loptičky a oblečenie';
  }
}

export function resolveHomepageMetaByLang(
  lang?: string,
): { title: string; description: string; keywords: string } {
  switch (lang) {
    case 'cz':
      return {
        title: 'Golfový obchod',
        description:
          'Golf e-shop na golfové hole, golfové bagy, golfové míčky, golfové oblečení a golfovou obuv. Kompletní vybavení pro amatérské i profesionální hráče golfu.',
        keywords:
          'golfové oblečení, golfová obuv, golfové hole, golfový obchod, golf e-shop',
      };
    case 'en':
      return {
        title: 'Golf shop',
        description:
          'Golf e-shop with golf clubs, golf bags, golf balls, golf apparel and golf shoes. Complete equipment for amateur and professional golfers.',
        keywords:
          'golf apparel, golf shoes, golf clubs, golf shop, golf e-shop',
      };
    default:
      return {
        title: 'Golfový obchod',
        description:
          'Golf e-shop na golfové palice, golfové bagy, golfové loptičky, golfové oblečenie a golfovú obuv. Kompletné vybavenie pre amatérov aj profesionálov.',
        keywords:
          'golfové oblečenie, golfová obuv, golfové palice, golfový obchod, golf e-shop',
      };
  }
}
